module.exports = __webpack_public_path__ + "084699860a79bb3aaed4c37da7870d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatsapp.png
// module id = 467
// module chunks = 3